// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:slug*?\",\"regex\":\"^/(.*)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.0";globalThis["_sentryRewritesTunnelPath"] = "/am80mixq";import '@/utils/canPlayTypeGuard';
import '@/utils/chunkLoadErrorGuard';
import '@/utils/domMutationGuard';
import * as Sentry from '@sentry/nextjs';

import { filterExtensionInjectedSentryEvent, sentryExtensionIgnoreErrors } from './src/utils/sentryFilter';

const ua = navigator?.userAgent?.toUpperCase();
const isMetaMask = ua?.includes('METAMASK');

if (!isMetaMask) {
  Sentry.init({
    dsn: 'https://cee308f05b474f7e0fe52b19cbdfce2f@o1241866.ingest.us.sentry.io/4508011356160000',

    sendDefaultPii: true,
    // Session Replay is intentionally NOT enabled: rrweb's MutationObserver
    // amplifies heavy mounts and high-churn lists into long tasks / ~12fps
    // scrolling on sampled sessions, and we only consumed it for issue context.
    // Error monitoring / issue stats are unaffected (replay is a separate
    // pipeline). If it ever comes back, re-add Sentry.replayIntegration with
    // block: ['[data-sentry-block]'] — those DOM markers are still in place on
    // the virtualized lists.

    tracesSampleRate: 0.1,
    profilesSampleRate: 0.1,

    debug: false,
    environment: process.env.NEXT_PUBLIC_PARTICLE_ENV,
    release: process.env.APP_VERSION,
    ignoreErrors: [...sentryExtensionIgnoreErrors, /applyStudiesOverrides/, /time.*violation/, /applyOverrides/],
    beforeSend: filterExtensionInjectedSentryEvent,
    _experiments: {
      ensureNoCircularStructures: true,
    },
    enabled: process.env.NODE_ENV === 'production',
  });
} else {
  console.log('Sentry is disabled for this browser');
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
